export default __webpack_public_path__ + "static/media/7.705cec50.png";